import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, BACKEND_URL } from "@/lib/api";
import { Crown, ArrowRight } from "lucide-react";

export default function HeroCoin() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/hero-coin").then((r) => { if (!cancelled) setInfo(r.data); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!info) return null;
  const hero = info.hero;

  if (!hero)
    return (
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-4">
        <Link
          to="/pricing"
          data-testid="hero-slot-teaser"
          className="group border border-dashed border-[#333] hover:border-[#ffd700] transition-colors flex items-center justify-between gap-4 px-5 py-3"
        >
          <span className="flex items-center gap-3 font-mono text-xs uppercase tracking-widest text-[#d0d0d0] group-hover:text-[#ffd700] transition-colors">
            <Crown size={14} className="text-[#ffd700] flex-shrink-0" />
            This spot is for sale — homepage hero · $149 / 30 days
          </span>
          <ArrowRight size={14} className="text-[#d0d0d0] group-hover:text-[#ffd700] group-hover:translate-x-1 transition-all flex-shrink-0" />
        </Link>
      </section>
    );

  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-4" data-testid="hero-coin-showcase">
      <div className="border border-[#ffd700] bg-[#121212] relative overflow-hidden">
        <div className="absolute top-0 left-6 bg-[#ffd700] text-[#050505] font-mono text-[11px] uppercase tracking-widest px-2 py-0.5 flex items-center gap-1">
          <Crown size={10} fill="currentColor" /> Homepage hero
        </div>
        <div className="p-6 pt-9 grid grid-cols-12 gap-5 items-center">
          <div className="col-span-12 md:col-span-8 flex items-center gap-5 min-w-0">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0 border-2 border-[#ffd700] bg-[#050505] overflow-hidden">
              <img
                src={`${BACKEND_URL}/api/coins/${hero.slug}/logo`}
                alt={hero.name}
                className="w-full h-full object-cover"
                onError={(e) => { e.currentTarget.style.display = "none"; }}
              />
            </div>
            <div className="min-w-0">
              <div
                className="font-display font-black text-2xl sm:text-4xl uppercase tracking-tighter truncate"
                data-testid="hero-coin-name"
              >
                {hero.name}
              </div>
              <div className="font-mono text-xs text-[#e2e2e2] mt-1">
                <span className="text-[#ffd700]">${hero.ticker}</span> · {hero.theme}
                {hero.tagline && <span className="hidden sm:inline"> · "{hero.tagline}"</span>}
              </div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 flex md:justify-end">
            <Link
              to={`/c/${hero.slug}`}
              data-testid="hero-coin-view"
              className="btn-brutal bg-[#ffd700] text-[#050505] font-bold uppercase tracking-wider text-sm px-6 py-3 inline-flex items-center gap-2"
            >
              View coin <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
